export const COOKIE_APPEARANCE = 'appearance'
